import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import { Avatar, Box, Button, Divider, lighten, Paper, Popover, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { signOut } from 'aws-amplify/auth';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../../contexts';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

export function HeaderUserbox() {
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };
  const nav = useNavigate();
  const { auth, setAuth, setAwsAuth } = useAuthContext();

  const handleSignOut = (): void => {
    signOut()
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setAwsAuth(undefined);
        setAuth(undefined);
        nav('/');
      });
  };

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar variant="rounded" alt={`${auth?.firstName} ${auth?.lastName}`} />
        <Paper sx={{ display: { xs: 'none', md: 'block' }, boxShadow: 'none' }}>
          <UserBoxText>
            <UserBoxLabel variant="body1">{auth ? `${auth?.firstName} ${auth?.lastName}` : ''}</UserBoxLabel>
            <UserBoxDescription variant="body2">{`${auth?.email}`}</UserBoxDescription>
          </UserBoxText>
        </Paper>
        <Paper sx={{ display: { xs: 'none', sm: 'block', boxShadow: 'none' } }}>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Paper>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar variant="rounded" alt={`${auth?.firstName} ${auth?.lastName}`} />
          <UserBoxText>
            <UserBoxLabel variant="body1">{auth ? `${auth?.firstName} ${auth?.lastName}` : ''}</UserBoxLabel>
            <UserBoxDescription variant="body2">{`${auth?.email}`}</UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        {/*//todo:v2-changes*/}
        <Box sx={{ p: 0, m: 1, display: 'grid', justifyContent: 'flex-start' }}>
          <Button
            color="primary"
            onClick={() => {
              nav(`/users/${auth?.id}`);
              setOpen(!isOpen);
            }}
          >
            My Profile
          </Button>
        </Box>
        <Divider />
        <Box sx={{ p: 0, m: 1, display: 'grid', justifyContent: 'flex-start' }}>
          <Button color="primary" fullWidth onClick={handleSignOut}>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
}
